import { Skeleton, Card } from 'antd';

const AssetDetailSkeleton = () => {
    return (
        <Card style={{ marginTop: 16 }}>
            <Skeleton active paragraph={{ rows: 6 }} />
            <Skeleton.Button active style={{ marginTop: 16 }} />
            <Skeleton active paragraph={{ rows: 4 }} style={{ marginTop: 16 }} />
        </Card>
    );
};

export default AssetDetailSkeleton;
